<div class="wrapper">
  <div class="content">
    <div class="content-header">
      <div class="section-title">{{ '+INSTALLATION_DETAILS.DASHBOARD' | translate }}</div>
      <button
        class="save-btn"
        mat-raised-button
        color="primary"
        gtm="onSave"
        gtmAction="Installation Details Tiles Order"
        gtmCategory="DragDrop"
        (click)="saveLayout()"
      >
        <mat-icon>check</mat-icon>
      </button>
    </div>
    <ng-container [ngSwitch]="installationDetailsStore.getSelectedDashboardTypeHelper$ | async">
      <ng-container *ngSwitchCase="dashboardTypes.WALLBOX">
        <ng-container *ngIf="uiService.idOfOpenedWallboxDevice$ | async as wallboxDeviceId">
          <div
            class="panel-list"
            cdkDropList
            (cdkDropListDropped)="drop($event, wallboxPrefix + wallboxDeviceId)"
          >
            <div
              class="drag-item"
              *ngFor="let panel of allDragDropDevicesPanels[wallboxPrefix + wallboxDeviceId]"
              cdkDrag
            >
              <mat-icon>menu</mat-icon>
              <ng-container *ngIf="panel.panel !== panelTypes.EcoWater; else ecoWaterPanel">
                <span>{{ panel.panel | translatePanelName }}</span>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <ng-container *ngIf="!(devicesStore.isV2Cascade$ | async); else cascadeDragDrop">
          <div class="panel-list" cdkDropList (cdkDropListDropped)="drop($event, orderKey)">
            <div class="drag-item" *ngFor="let panel of allDragDropDevicesPanels[orderKey]" cdkDrag>
              <mat-icon>menu</mat-icon>
              <ng-container *ngIf="panel.panel !== panelTypes.EcoWater; else ecoWaterPanel">
                <span>{{ panel.panel | translatePanelName }}</span>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-template #cascadeDragDrop>
      <div class="cascade-device">
        <!-- Display deviceId panels in the first order -->
        <div class="panel-list" cdkDropList (cdkDropListDropped)="drop($event, orderKey)">
          <div class="drag-item" *ngFor="let panel of allDragDropDevicesPanels[orderKey]" cdkDrag>
            <mat-icon>menu</mat-icon>
            <ng-container *ngIf="panel.panel !== panelTypes.EcoWater; else ecoWaterPanel">
              <span>{{ panel.panel | translatePanelName }}</span>
            </ng-container>
          </div>
        </div>
      </div>
      <ng-container *ngFor="let panel of allDragDropDevicesPanels | keyvalue">
        <div class="cascade-device" *ngIf="panel.key !== orderKey">
          <div class="section-title">
            {{
              '+INSTALLATIONS.INSTALLATION.CASCADES.MULTIVALENT.DEVICE.' +
                (
                  devicesStore.getCascadeDeviceById(getDeviceIdFromOrderKey(panel.key)) | async
                )?.deviceType.toUpperCase() | translate
            }}
          </div>
          <div class="panel-list" cdkDropList (cdkDropListDropped)="drop($event, panel.key)">
            <div class="drag-item" *ngFor="let panel of panel.value" cdkDrag>
              <mat-icon>menu</mat-icon>
              <ng-container *ngIf="panel.panel !== panelTypes.EcoWater; else ecoWaterPanel">
                <span>{{ panel.panel | translatePanelName }}</span>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-template>
  </div>
</div>

<ng-template #ecoWaterPanel>
  <ng-container *ngIf="deviceVariant$ | async | ready as deviceVariant">
    <span>{{
      deviceVariant | value2: featurePropertyKey.value | translateEcowaterDeviceVariant
    }}</span>
  </ng-container>
</ng-template>
